module.exports = __webpack_public_path__ + "img/icon-facebook-white.90b3ffa6.svg";